import { useEffect, useState } from "react";
import {
  DeltaHedgeExeProcess,
  IAllowedTradesSearchParam,
} from "../../../Interfaces/deltaHedgeExe";
import { DropdownItem } from "../../../Interfaces/dropdownInterfaces";
import SelectableButtons from "../../../Components/Dropdown/SelectableButtons";
import AllowedTradesTable from "../../../Tables/DeltaHedgeExePhase3/AllowedTrades/AllowedTradesTable";
import { getDeltaHedgeExeStrategies } from "src/Requests/deltaHedgeExe";
import { packetErrorHandler } from "src/Utils/requestUtils";
import { Button, Modal } from "src/Components";
import StrategiesModal from "./StrategiesModal";

const AllowedTrades = () => {
  const [searchParams, setSearchParams] = useState(
    {} as IAllowedTradesSearchParam
  );
  const [refreshStrategiesFlag, setRefreshStrategiesFlag] = useState(true);
  const [strategies, setStrategies] = useState<DropdownItem[]>([]);
  const [isStrategyModalOpen, setIsStrategyModalOpen] = useState(false);

  useEffect(() => {
    if (!refreshStrategiesFlag) return;

    fetchStrategies();
  }, [refreshStrategiesFlag]);

  const fetchStrategies = async () => {
    getDeltaHedgeExeStrategies()
      .then((response) => {
        setStrategies(response);
        setSearchParams((prev) => ({
          ...prev,
          strategyEnum: response[0]?.id?.toString(),
        }));
      })
      .catch(packetErrorHandler)
      .finally(() => {
        setRefreshStrategiesFlag(false);
      });
  };

  const changeHandler = (name: string, value: any) => {
    setSearchParams({ ...searchParams, [name]: value });
  };

  const processes: DropdownItem[] = [
    { id: DeltaHedgeExeProcess.Adjustment, name: "تعدیل" },
  ];

  return (
    <div className="w-full flex flex-col justify-start items-start gap-3">
      {isStrategyModalOpen ? (
        <Modal
          UI={
            <StrategiesModal
              strategies={strategies}
              setRefreshStrategiesFlag={setRefreshStrategiesFlag}
            />
          }
          onClose={() => setIsStrategyModalOpen(false)}
        />
      ) : (
        <></>
      )}
      <div className="flex flex-row justify-start items-center gap-16 w-full">
        <div className="w-min">
          <SelectableButtons
            label="فرایند"
            name="processEnum"
            onChange={changeHandler}
            options={processes}
            value={searchParams.processEnum}
          />
        </div>
        <div className="w-min">
          <SelectableButtons
            label="استراتژی"
            name="strategyEnum"
            onChange={changeHandler}
            options={strategies}
            value={searchParams.strategyEnum}
            hideSelectAll
          />
        </div>
        <Button
          text="ویرایش استراتژی"
          onClick={() => setIsStrategyModalOpen(true)}
          variant="contained"
          className="!w-min !mr-auto"
        />
      </div>
      <AllowedTradesTable searchParams={searchParams} />
    </div>
  );
};

export default AllowedTrades;
